<p class="text-2xl font-bold text-center">
  <ng-content select="[title]"></ng-content>
</p>
<p class="text-center">
  <ng-content select="[subtitle]"></ng-content>
</p>
<ng-content></ng-content>
